import { render } from "./component-payment-doc-type.vue?vue&type=template&id=5b6a9c43"
import script from "./component-payment-doc-type.vue?vue&type=script&setup=true&lang=js"
export * from "./component-payment-doc-type.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-payment-doc-type.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b6a9c43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b6a9c43', __exports__)) {
    api.reload('5b6a9c43', __exports__)
  }
  
  module.hot.accept("./component-payment-doc-type.vue?vue&type=template&id=5b6a9c43", () => {
    api.rerender('5b6a9c43', render)
  })

}


export default __exports__